'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { usePathname } from 'next/navigation';
import { useShallow } from 'zustand/react/shallow';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useGlobalStore } from '@/stores/GlobalStore';
export const LoginRedirectionConfirmModal = () => {
  const $ = _c(14);
  const router = useCustomRouter();
  const pathname = usePathname();
  const [isShowLoginRedirectionConfirmModal, setIsShowLoginRedirectionConfirmModal] = useGlobalStore(useShallow(_temp));
  let t0;
  if ($[0] !== pathname || $[1] !== router || $[2] !== setIsShowLoginRedirectionConfirmModal) {
    t0 = () => {
      setIsShowLoginRedirectionConfirmModal(false);
      router.push(ROUTES.LOGIN.withSearchParams({
        searchParams: {
          redirect: pathname ?? ""
        }
      }));
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = setIsShowLoginRedirectionConfirmModal;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleClickConfirm = t0;
  let t1;
  if ($[4] !== setIsShowLoginRedirectionConfirmModal) {
    t1 = () => {
      setIsShowLoginRedirectionConfirmModal(false);
    };
    $[4] = setIsShowLoginRedirectionConfirmModal;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleClose = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="mb-8 font-700 text-Gray-900 typo-body1">알림</p>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="mb-24 font-400 text-Gray-700 typo-body3">웰로에 회원가입을 하시고<br />정책 지원금을 확인해 보세요.</p>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleClickConfirm) {
    t4 = <Button className="cursor-pointer px-16 py-12 font-700 typo-body3" theme="primary-fill" onClick={handleClickConfirm}>웰로 시작하기</Button>;
    $[8] = handleClickConfirm;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== handleClose || $[11] !== isShowLoginRedirectionConfirmModal || $[12] !== t4) {
    t5 = <Modal className="flex flex-col items-center" opened={isShowLoginRedirectionConfirmModal} onClose={handleClose}>{t2}{t3}{t4}</Modal>;
    $[10] = handleClose;
    $[11] = isShowLoginRedirectionConfirmModal;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp(state) {
  return [state.isShowLoginRedirectionConfirmModal, state.setIsShowLoginRedirectionConfirmModal] as const;
}